module.exports = __webpack_public_path__ + "static/media/stadium_2.22ff24ee.jpg";